export default "__VITE_ASSET__D989xKsT__"